
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/be-seller",
      function () {
        return require("private-next-pages/be-seller.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/be-seller"])
      });
    }
  